export default __webpack_public_path__ + "static/media/video17.930c53f7.webp";